import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const dateTabStyle = (theme) => ({
	smallTab: {
		width: '60%',
		margin: '0 auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	tab: {
		marginTop: '24px',
		minHeight: '640px',
		backgroundColor: whiteColor,
		borderRadius: '8px',
	},
	headingWrapper: {
		padding: '24px 32px 32px 24px',
	},
	dateTabContainer: {
		textAlign: 'left',
		margin: '0 auto 0 auto',
		width: '50%',
		display: 'flex',
		flexDirection: 'column',
		maxWidth: '330px',
		paddingBottom: 50,
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			paddingLeft: '24px',
			paddingRight: '24px',
		},
	},
	datePicker: {
		display: 'flex',
		flexDirection: 'row',
		paddingTop: 20,
		'& > div:first-child': {
			marginTop: 4,
		},
		'& > div:nth-child(2)': {
			marginLeft: 8,
		},
	},
});

export default dateTabStyle;
